<script setup lang="ts">
import { useDevice } from '#imports'
import { computed } from 'vue'
import getCountryCode from '../../../../utils/shared/countryCode'

const props = defineProps({
    locale: {
        type: String,
        default: 'en'
    },
    cdnUrl: {
        type: String,
        default: ''
    }
})

const appStoreUrl = computed(
    () =>
        `https://itunes.apple.com/${getCountryCode(props.locale)}/app/chargemap-bornes-de-recharge/id438176982`
)

const playStoreUrl = computed(
    () =>
        `https://play.google.com/store/apps/details?id=com.chargemap_beta.android&hl=${props.locale}`
)
const { isAndroid, isApple } = useDevice()
</script>

<template>
    <div class="flex gap-3">
        <a
            :href="appStoreUrl"
            target="_blank"
            :title="$t('home.download.apple')"
            class="gtm-SousMenuIOS"
            :class="[isApple ? 'block' : 'hidden']"
        >
            <img
                :alt="$t('home.download.apple')"
                :src="`${cdnUrl}/images/cmp-store/${locale}/app-store-badge.svg`"
            />
        </a>
        <a
            :href="playStoreUrl"
            target="_blank"
            :title="$t('home.download.google')"
            class="gtm-SousMenuAndroid"
            :class="[isAndroid ? 'block' : 'hidden']"
        >
            <img
                :alt="$t('home.download.google')"
                :src="`${cdnUrl}/images/cmp-store/${locale}/google-play-badge.png`"
            />
        </a>
    </div>
</template>

<style scoped>
img {
  @apply h-11 lg:h-10;
}
</style>
